import clamp from 'lodash/clamp'
import isFinite from 'lodash/isFinite'
import round from 'lodash/round'

import { parseNumber } from '@utils/numberConversions'

// The range the annual increase slider offers.
export const ANNUAL_INCREASE_MIN = 0
export const ANNUAL_INCREASE_MAX = 15

// The slider works in whole percents while the plan stores a fraction. Shared so the
// checkbox label, the value the slider is pinned to, and the untick comparison can
// never drift apart.
//
// Clamped to the slider's range: a plan inflation above it cannot be shown on the
// slider, and letting it through leaves the handle sitting off the end of the track.
export const planInflationRate = (assumptions) => {
  const rate = parseNumber(assumptions?.inflation)
  if (!isFinite(rate)) return ANNUAL_INCREASE_MIN

  return clamp(round(rate * 100, 2), ANNUAL_INCREASE_MIN, ANNUAL_INCREASE_MAX)
}

// A following asset stores no rate of its own - the flag says where the rate comes
// from, and keeping a stale number alongside it would only mislead whoever read it.
// The server rejects the two together.
export const annualIncreaseInMonthlyContributionFor = (asset) => {
  if (asset.usePlanInflation) return null

  const entered = parseNumber(asset.annualIncreaseInMonthlyContribution)

  return isFinite(entered) ? entered / 100 : 0
}

// Moving the slider away from the plan's rate is what unticks the box. Compared at the
// slider's own precision so float noise cannot untick it on its own.
export const shouldUntickPlanInflation = (value, planRate) =>
  round(parseNumber(value), 2) !== round(planRate, 2)
